<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Facturas de compras a proveedores</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-inline justify-content-sm-end">
                <input
                  style="width: 150px"
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                  v-on:keyup.enter="filterData()"
                />
                <input
                  style="width: 100px"
                  class="form-control form-control-sm rounded bright"
                  placeholder="Filtrar número"
                  v-model="filter.numero"
                  type="text"
                  v-on:keyup.enter="filterData()"
                />
                <input
                  style="width: 100px"
                  class="form-control form-control-sm rounded bright"
                  placeholder="Filtrar serie"
                  v-model="filter.serie"
                  type="text"
                  v-on:keyup.enter="filterData()"
                />
                <ProveedoresSelectComponent
                  style="display: block; width: 350px"
                  titulo=""
                  :current="filter"
                  @change="filterData()"
                  @onChange="filterData()"
                />
                <div class="input-group-append">
                  &nbsp; &nbsp; &nbsp;
                  <TiendaSelectComponent
                    @change="filterData()"
                    titulo="hide"
                    :current="filter"
                  />
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="filterData()"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData()"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filtro_estado"
                  @change="filterData()"
                >
                  <option value>Todos</option>
                  <option value="9">Anulado</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                  <option value="C">Finalizado</option>
                </select>
              </div>
            </div>
          </div>

          <FacturaTableComponent :facturas="facturas" />
        </div>
        <PaginationComponent
          :currentPage="currentPage"
          :data="facturas"
          @pagechanged="filterData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import FacturaTableComponent from "@/components/compras/facturas_proveedores/FacturaTableComponent";
import DynamicService from "@/services/commons/DynamicService";
import PaginationComponent from "@/components/utils/PaginationComponent";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  components: {
    FacturaTableComponent,
    UsuarioEnTablaComponent,
    PaginationComponent,
    ProveedoresSelectComponent,
    TiendaSelectComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      facturas: "",
      filter: {
        numero: "",
        serie: "",
        proveedor: "",
      },
    };
  },
  mounted() {
    let self = this;
    self.refreshFacturas();
  },
  methods: {
    refreshFacturas(params) {
      let self = this;
      DynamicService.fetch("wms", "facturas", params).then((response) => {
        self.facturas = response.data;
      });
    },
    filterData(page) {
      this.currentPage = 1;
      if (page) {
      this.currentPage = page;
      }
      DynamicService.fetch("wms", "facturas", {
         page: page,
        proveedor: this.filter.proveedor.codigo,
        documento: this.filter.numero,
        recepcion__tienda: this.filter.tienda,
        serie: this.filter.serie,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
      })
        .then((response) => {
          this.facturas = response.data;
        })
        .catch((error) => {
          this.data = "";
        });
    },
    clearFilterData() {
      this.filtro_estado = "";
      this.filter.tienda = "";
      this.searchtext = "";
      this.$data.currentPage = 1;
      this.filterData();
      this.filter.numero = "";
      this.filter.proveedor = "";
      this.filter.serie = "";
      this.filterData();
    },
  },
};
</script>
